"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pipe_1 = __importDefault(require("lodash/fp/pipe"));
const react_1 = __importStar(require("react"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const libs_utils_1 = require("@hotelplan/libs.utils");
const DOBInput_utils_1 = require("./DOBInput.utils");
const DOBBaseInput = (0, styled_components_1.default)(components_common_inputs_1.BaseInput)(({ invalid, theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.input': {
        height: '40px',
        px: ['11px', '18px'],
        fontSize: 2,
        borderColor: invalid ? colors.warning : undefined,
    },
}));
const IosDOBBaseInput = (0, styled_components_1.default)(DOBBaseInput).attrs({
    type: `date`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.input': {
        pl: '11px',
        pr: 0,
    },
}));
const ActionButtonWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    position: 'relative',
}));
const ActionButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    className: 'action-button',
    variant: 'iconBtn',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'relative',
    border: '1px solid',
    borderLeft: 'none',
    borderColor: 'lightGray',
    px: 2,
}));
const IOSDobInput = ({ value = '', onChange, onBlur, maxAge, invalid, className, name, icon, label, hideLabel, disabled, }) => {
    return (react_1.default.createElement(IosDOBBaseInput, { hideLabel: hideLabel, label: label, value: value ? (0, DOBInput_utils_1.parseDOBFormatToNativeDateFormat)(value) : '', invalid: !!invalid, min: maxAge ? (0, DOBInput_utils_1.getOldestDOBInNativeDateFormat)(maxAge) : undefined, max: (0, DOBInput_utils_1.getYoungestDOBInNativeDateFormat)(), onChange: e => {
            onChange((0, DOBInput_utils_1.parseNativeDateFormatToDOBFormat)(e.target.value), e);
        }, onBlur: e => {
            onBlur((0, DOBInput_utils_1.parseNativeDateFormatToDOBFormat)(e.target.value), e);
        }, className: className, name: name, icon: icon, disabled: disabled }));
};
function getTargetValue(e) {
    return e.target.value;
}
const DOBInputWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
}));
const DOBInput = props => {
    const { value = '', placeholder = '', onBlur, onChange, invalid, name, icon, hideLabel, label, className, required, actionButton, isTypeDate, isIOSDobInputDisabled, disabled, inputRef, } = props;
    const [showActionButtonComponent, , close, toggle] = (0, libs_hooks_react_1.useToggleState)(false);
    const onInputChange = (0, react_1.useCallback)((e) => {
        onChange(getTargetValue(e), e);
    }, [onChange]);
    const onInputBlur = (0, react_1.useCallback)((e) => {
        onBlur((0, pipe_1.default)(getTargetValue, DOBInput_utils_1.transformUserInput)(e), e);
    }, [onBlur]);
    if (isTypeDate || (libs_utils_1.isIOS && !isIOSDobInputDisabled))
        return react_1.default.createElement(IOSDobInput, Object.assign({}, props));
    return (react_1.default.createElement(DOBInputWrapper, null,
        react_1.default.createElement(react_input_mask_1.default, { mask: "99/99/9999", value: value, onChange: onInputChange, onBlur: onInputBlur, disabled: disabled, beforeMaskedValueChange: DOBInput_utils_1.beforeMaskedValueChange }, (inputMaskProps) => (react_1.default.createElement(DOBBaseInput, { inputRef: inputRef, hideLabel: hideLabel, label: label, placeholder: placeholder, disabled: disabled, value: inputMaskProps.value, invalid: !!invalid, className: className, name: name, icon: icon, required: required }))),
        (actionButton === null || actionButton === void 0 ? void 0 : actionButton.enabled) ? (react_1.default.createElement(ActionButtonWrapper, { className: 'action-button-wrapper' },
            react_1.default.createElement(ActionButton, { icon: (actionButton === null || actionButton === void 0 ? void 0 : actionButton.icon) || {
                    name: `calendar`,
                    size: 'xs',
                }, onClick: toggle }),
            showActionButtonComponent
                ? actionButton.component({
                    dateFromField: (0, libs_utils_1.parseDateStr)(value, DOBInput_utils_1.DOB_INPUT_FORMAT),
                    onClose: close,
                    onChange,
                })
                : null)) : null));
};
exports.default = DOBInput;
//# sourceMappingURL=DOBInput.js.map